export function getUrlWithoutOrigin(url: string) {
  const parsedUrl = new URL(url);
  return parsedUrl.toString().substring(parsedUrl.origin.length) || '/';
}
